import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=cb3cf6a6&scoped=true"
import script from "./volunteer.vue?vue&type=script&lang=js"
export * from "./volunteer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3cf6a6",
  null
  
)

export default component.exports